import clsx from "clsx"
import { Children, useContext } from "react"

import { PopoverContext } from "@molecules/Popover/Popover"
import { Popover } from "@molecules/index"

import { SidePanelContentContext } from "./SidePanelContent.context"
import styles from "./SidePanelContent.module.scss"
import type { SidePanelContentProps } from "./SidePanelContent.types"

function SidePanelContent(props: SidePanelContentProps) {
    const { children, className } = props
    const { isOpen, setIsOpen } = useContext(PopoverContext)

    const childrenArray = Children.toArray(children)
    const hasFilePreview = childrenArray.length > 1

    return (
        <>
            <Popover.Overlay isActive={isOpen} onClick={() => setIsOpen(false)} />
            <Popover.Viewport
                className={clsx(styles.base, {
                    [styles.hasFilePreview]: hasFilePreview,
                })}
            >
                <SidePanelContentContext.Provider value={{ hasFilePreview }}>
                    <div className={clsx(styles.content, className)}>{children}</div>
                </SidePanelContentContext.Provider>
            </Popover.Viewport>
        </>
    )
}

export default SidePanelContent
